































import { Component } from 'vue-mixin-decorator';
import BaseView from '@/views/BaseView.vue';
import ExamFooter from '@/components/ExamFooter.vue';
import ExamGuide from '@/components/ExamGuide.vue';
import ExamNav from '@/components/ExamNav.vue';
import ReCAPTCHA from '@/components/ReCAPTCHA.vue';
import ReCAPTCHABranding from '@/components/ReCAPTCHABranding.vue';
import IndicatorModal from '@/components/IndicatorModal.vue';

import * as StringUtil from '@/common/StringUtil';
import * as Msgs from '@/common/Messages';
import * as RouterPath from '@/classification/RouterPath';

import IdForgetParam from '@/models/account/IdForgetParam';
import RepositoryFactory from '@/repository/RepositoryFactory';

@Component(
  {
    components: {
      'e-footer': ExamFooter,
      'e-guide': ExamGuide,
      'e-nav': ExamNav,
      'e-indicator': IndicatorModal,
      're-captcha-branding': ReCAPTCHABranding,
    },
  },
)
export default class IdForget extends BaseView {
  private routerPath = RouterPath;

  private idForgetParam = new IdForgetParam();

  private reCAPTCHA = new ReCAPTCHA();

  private isIndicatorDisplay = false;

  private isEmailEmpty = false;

  private isEmailConfirmEmpty = false;

  private isSendMailFail = false;

  private sendMailFailMessage = '';

  private msgs = Msgs;

  private mounted() {
    const CommonCss = document.createElement('link');
    CommonCss.rel = 'stylesheet';
    CommonCss.href = '/css/common.css';
    this.$el.appendChild(CommonCss);

    const AccountCommonCss = document.createElement('link');
    AccountCommonCss.rel = 'stylesheet';
    AccountCommonCss.href = '/account/css/common.css';
    this.$el.appendChild(AccountCommonCss);

    this.getExamConfigCss().then((cssElement: HTMLLinkElement) => {
      this.$el.appendChild(cssElement);
    });

    const CommonJs = document.createElement('script');
    CommonJs.src = '/js/common.js';
    this.$el.appendChild(CommonJs);
  }

  /**
   * IDを忘れたユーザーへの通知メール送信処理
   * 入力されたメールアドレスにID通知メールを送信し、ID通知完了画面へ遷移
   */
  async idForget() {
    this.isIndicatorDisplay = false;
    this.isSendMailFail = false;

    this.isEmailEmpty = StringUtil.isEmpty(this.idForgetParam.email);
    this.isEmailConfirmEmpty = StringUtil.isEmpty(this.idForgetParam.emailConfirm);
    if (this.isEmailEmpty || this.isEmailConfirmEmpty) return;

    if (this.idForgetParam.email !== this.idForgetParam.emailConfirm) {
      this.isSendMailFail = true;
      this.sendMailFailMessage = Msgs.MAIL_ADDRESS_MISMATCH;
      return;
    }

    try {
      this.isIndicatorDisplay = true;

      await this.reCAPTCHA.getToken('remind_id')
        .then((token) => {
          this.idForgetParam.reCaptchaToken = token;
        });
      const AccountRepository = RepositoryFactory.get().account;
      await AccountRepository.idForget(this.idForgetParam)
        .then((response) => {
          if (response.status === 204) {
            this.$router.replace(this.paths.ID_FORGET_COMPLETE);
          } else {
            this.isSendMailFail = true;
            this.sendMailFailMessage = Msgs.SEND_MAIL_FAILURE;
          }
        })
        .catch((err) => {
          this.isSendMailFail = true;
          this.sendMailFailMessage = Msgs.SEND_MAIL_FAILURE;
        });
    } catch (e) {
      this.isSendMailFail = true;
      this.sendMailFailMessage = Msgs.SEND_MAIL_FAILURE;
    } finally {
      this.isIndicatorDisplay = false;
    }
  }
}
